import _ from "lodash";
import { Dispatch, SetStateAction, useMemo, useState } from "react";

type ReturnType<T> = {
  state: T,
  setState: Dispatch<SetStateAction<T>>,
  isDirty: boolean,
  resetState: Dispatch<SetStateAction<T>>,
}

export default function useStateWithDirty<T>(intial: (T | (() => T))): ReturnType<T> {
  const [initialState, setInitialState] = useState<T>(intial);
  const [currentState, setCurrentState] = useState<T>(intial);

  const isDirty = useMemo(() => !_.isEqual(initialState, currentState), [initialState, currentState]);

  const resetState = (newState: SetStateAction<T>) => {
    setInitialState(newState);
    setCurrentState(newState);
  };

  return {
    state: currentState,
    setState: setCurrentState,
    isDirty,
    resetState,
  };
}
